import { CommonModule } from '@angular/common';
import { Component, inject, Input, model, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';

import {
  AgendaDataService,
  AgendaService,
} from '@nomoh-monorepo/data-access-bardo-administrador';
import {
  BottomSheetComponent,
  DeviceService,
  IAgendamento,
} from '@nomoh-monorepo/shared-common-ui';
import { AgendaInformacaoAgendamentoComponent } from './agenda-informacao-agendamento/agenda-informacao-agendamento.component';

/**
 * Modal de informações detalhadas de um agendamento
 * Exibe: Status, Cliente, Telefone, Serviço, Profissional, Observação
 * Ações: Cancelar, Confirmar, Finalizar (baseado no status)
 */
@Component({
  selector: 'lib-agenda-modal-informacao-agendamento',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    FormsModule,
    TextareaModule,
    BottomSheetComponent,
    AgendaInformacaoAgendamentoComponent,
  ],
  templateUrl: './agenda-modal-informacao-agendamento.component.html',
  styleUrl: './agenda-modal-informacao-agendamento.component.scss',
})
export class AgendaModalInformacaoAgendamentoComponent {
  //#region iputs
  @Input() agendamento: IAgendamento = {} as IAgendamento;
  //#endregion

  //#region Injeção de Dependências
  readonly AgendaService = inject(AgendaService);
  readonly AgendaDataService = inject(AgendaDataService);

  deviceService = inject(DeviceService);
  //#endregion
  //#region signals
  $modalIsVisible = model(false);

  //#endregion

  //#region propriedades
  headerTemplate: TemplateRef<unknown> | null = null;
  footerTemplate: TemplateRef<unknown> | null = null;
  //#endregion

  fecharModal(): void {
    this.$modalIsVisible.set(false);
    this.headerTemplate = null;
    this.footerTemplate = null;
  }

  headerTemplateAction(template: TemplateRef<unknown>): void {
    this.headerTemplate = template;
  }

  footerTemplateAction(template: TemplateRef<unknown>): void {
    this.footerTemplate = template;
  }
}
